import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiForumBreadcrumb } from '@wix/da-papi-types';
import { sanitizeHref } from '@wix/da-url';
import { urlTo, urlFromForumpath } from '../../helpers/url';
import { Fragment } from 'react';

import s from './Breadcrumbs.scss';

export interface Props {
  className?: string;
  breadcrumbs?: PapiForumBreadcrumb[];
  /** Optional text transform function to update each link in the breadcrumbs */
  transformLinkFn?: (link: string) => string;
}

/** this > style > of > nav for forums */
const Breadcrumbs: React.FC<Props> = ({ className, breadcrumbs = [], transformLinkFn = urlTo }) => {
  const { t } = useTranslation();

  if (!breadcrumbs.length) {
    return null;
  }

  const crumbsWithForumHome = [
    {
      name: t('Breadcrumbs.rootForumName'),
      link: urlFromForumpath('/'),
    },
    ...breadcrumbs,
  ];
  const lastCrumb = crumbsWithForumHome[crumbsWithForumHome.length - 1];

  return (
    <nav className={cn(s['root'], className)}>
      {crumbsWithForumHome.map(breadcrumb => {
        const { name, link } = breadcrumb;
        const isLastCrumb = breadcrumb === lastCrumb;
        const classes = cn(isLastCrumb && s['last'], s['breadcrumb']);
        return (
          <Fragment key={name}>
            <a className={classes} href={sanitizeHref(transformLinkFn(link))}>
              {name}
            </a>

            {!isLastCrumb && <span aria-hidden> &gt; </span>}
          </Fragment>
        );
      })}
    </nav>
  );
};
Breadcrumbs.displayName = 'Breadcrumbs';

export default Breadcrumbs;
